import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "primeng/api";
import { RespostaPaginada } from "./../../../shared/model/sgsia/paginacao-sgsia";
import { SuspensaoInstituicaoSgsia } from "./../../../shared/model/sgsia/suspensao-instituicao-sgsia";
import { SegurancaService } from "./../../../shared/service/seguranca.service";

@Component({
    selector: "app-aviso-suspensao-intituicao",
    templateUrl: "./aviso-suspensao-intituicao.component.html",
    styleUrls: ["./aviso-suspensao-intituicao.component.scss"],
})
export class AvisoSuspensaoIntituicaoComponent implements OnInit {
    isGestor: boolean;
    isFiscal: boolean;
    @Input()
    paginacaoSuspensoes: RespostaPaginada<SuspensaoInstituicaoSgsia>;
    @Input()
    loadLazy: (event: any) => void;

    constructor(
        private segurancaService: SegurancaService,
        private router: Router,
        private dialogService: DialogService
    ) {}

    ngOnInit() {
        this.isGestor = this.segurancaService.isGestor();
        this.isFiscal = this.segurancaService.isAnalistaFiscal();
    }

    solicitarReativacao(item: SuspensaoInstituicaoSgsia) {
        this.dialogService.dialogComponentRef.destroy();
        this.router.navigate([
            "/gestao-acesso/reativar-instituicao/suspensao",
            item.idSuspensao,
        ]);
    }

    analisarReativacao(item: SuspensaoInstituicaoSgsia) {
        this.dialogService.dialogComponentRef.destroy();
        this.router.navigate([
            "/gestao-acesso/avaliar-reativacao/suspensao",
            item.idSuspensao,
        ]);
    }
}
